import { appV2EventPrefix } from "@src/appV2/lib/analytics/events";

export const IN_HOME_USER_EVENTS = {
  VISIT_BOOKED: `${appV2EventPrefix} Home Health Visit Booked`,
  VISIT_LOGGED: `${appV2EventPrefix} Home Health Visit Logged`,
  VISIT_DROPPED: `${appV2EventPrefix} Home Health Visit Dropped`,
  VISIT_CONFIRMED: `${appV2EventPrefix} Home Health Visit Confirmed`,
  VISIT_PENDED: `${appV2EventPrefix} Home Health Visit Pended`,
};

export const IN_HOME_APP_EVENTS = {
  GET_BOOKED_CASES_FAILURE: `${appV2EventPrefix} Home Health Failed to load booked cases`,
  GET_SIGNATURES_FAILURE: `${appV2EventPrefix} Home Health Failed to load signatures`,
  GET_WORKER_STATISTICS_FAILURE: `${appV2EventPrefix} Home Health Failed to load worker statistics`,
};
